// Comprehensive Fruits & Vegetables Catalogue Data for SPANXPORT

export const produceData = [
  // === FRESH FRUITS ===
  {
    id: "alphonso-mango",
    name: "Alphonso Mango",
    botanicalName: "Mangifera indica",
    category: "fresh-fruits",
    subcategory: "mango",
    image: "alphonso-mango",
    description: "Alphonso, known as the 'King of Mangoes', is India's most premium mango variety. Grown primarily in the Ratnagiri and Devgad regions of Maharashtra, it's renowned for its rich, creamy texture, intense sweetness, and distinctive saffron color.",
    origin: "Maharashtra (Ratnagiri, Devgad), Gujarat, Karnataka - India",
    season: "April to June",
    characteristics: "Medium size, golden-yellow skin, rich saffron pulp, minimal fiber, intense aroma",
    culinaryUses: "Fresh consumption, premium desserts, ice cream, smoothies, export-grade fruit baskets",
    nutritionalInfo: "Vitamin A, Vitamin C, potassium, fiber, antioxidants (beta-carotene)",
    specifications: {
      size: "150-300g per fruit",
      brix: "Min 16°",
      color: "Golden yellow with reddish blush",
      pulpPercentage: "70-75%",
      fiberContent: "Very low"
    },
    grades: ["GI Tagged Ratnagiri", "Devgad", "Premium Export"],
    packaging: "2kg/5kg boxes, air-freight packaging",
    shelfLife: "7-10 days (fresh), Cold storage extends",
    certifications: "GI Tag, GlobalGAP, FSSAI"
  },
  {
    id: "kesar-mango",
    name: "Kesar Mango",
    botanicalName: "Mangifera indica",
    category: "fresh-fruits",
    subcategory: "mango",
    image: "kesar-mango",
    description: "Kesar mango from Gujarat is the second most popular Indian mango variety. Known for its distinct fragrance and sweet taste, it's particularly prized for its pulp which is used extensively in mango-based products.",
    origin: "Gujarat (Gir region), Maharashtra - India",
    season: "May to July",
    characteristics: "Medium size, greenish-yellow skin, deep orange pulp, sweet aroma",
    culinaryUses: "Fresh eating, pulp/puree production, ice cream, mango shakes",
    nutritionalInfo: "Vitamin A, Vitamin C, potassium, dietary fiber",
    specifications: {
      size: "200-350g per fruit",
      brix: "Min 15°",
      color: "Green-yellow, orange pulp",
      pulpPercentage: "68-72%"
    },
    grades: ["GI Tagged Gir Kesar", "Premium", "Standard"],
    packaging: "5kg/10kg boxes",
    shelfLife: "10-12 days",
    certifications: "GI Tag, FSSAI"
  },
  {
    id: "totapuri-mango",
    name: "Totapuri Mango",
    botanicalName: "Mangifera indica",
    category: "fresh-fruits",
    subcategory: "mango",
    image: "totapuri-mango",
    description: "Totapuri, named for its parrot-beak shape, is one of India's most commercially significant mango varieties. Its firm flesh and tangy-sweet taste make it ideal for industrial processing into pulp, pickles, and canned products.",
    origin: "Andhra Pradesh, Karnataka, Tamil Nadu - India",
    season: "March to July",
    characteristics: "Large, elongated, parrot-beak tip, tangy-sweet, firm flesh",
    culinaryUses: "Mango pulp/puree, pickles, canned mango, food processing",
    nutritionalInfo: "Vitamin C, dietary fiber, lower sugar than dessert mangoes",
    specifications: {
      size: "350-500g per fruit",
      brix: "Min 12°",
      color: "Green-yellow",
      pulpPercentage: "65-70%"
    },
    grades: ["A Grade", "B Grade", "Processing Grade"],
    packaging: "20kg crates, bulk",
    shelfLife: "12-15 days",
    certifications: "FSSAI"
  },
  {
    id: "thompson-grapes",
    name: "Thompson Seedless Grapes",
    botanicalName: "Vitis vinifera",
    category: "fresh-fruits",
    subcategory: "grapes",
    image: "thompson-grapes",
    description: "Thompson Seedless is India's primary export grape variety. Grown extensively in Maharashtra and Karnataka, these pale green, seedless grapes are sweet, crisp, and ideal for table consumption and raisin production.",
    origin: "Nashik (Maharashtra), Sangli, Karnataka - India",
    season: "January to April",
    characteristics: "Medium, oval, seedless, pale green, crisp, sweet",
    culinaryUses: "Fresh consumption, raisin production, wine making, fruit salads",
    nutritionalInfo: "Natural sugars, vitamin K, vitamin C, antioxidants",
    specifications: {
      berrySize: "16-22mm diameter",
      brix: "Min 18°",
      color: "Pale green to golden",
      seedless: "100%"
    },
    grades: ["Premium Export", "Grade A", "Grade B"],
    packaging: "2kg/4.5kg punnets, 8kg boxes",
    shelfLife: "30-45 days (cold storage)",
    certifications: "GlobalGAP, FSSAI"
  },
  {
    id: "pomegranate",
    name: "Pomegranate (Bhagwa)",
    botanicalName: "Punica granatum",
    category: "fresh-fruits",
    subcategory: "pomegranate",
    image: "pomegranate",
    description: "Bhagwa is India's premium pomegranate variety with attractive red skin and ruby-red, soft-seeded arils. Maharashtra is the largest producer, with exports going to Europe, Middle East, and Southeast Asia.",
    origin: "Maharashtra (Solapur, Nashik), Karnataka, Gujarat - India",
    season: "Year-round (peak: August-February)",
    characteristics: "Large fruit, deep red skin, ruby arils, soft seeds, sweet-tart",
    culinaryUses: "Fresh consumption, juice, salads, garnish, Middle Eastern cuisine",
    nutritionalInfo: "Antioxidants (punicalagins), vitamin C, vitamin K, potassium",
    specifications: {
      fruitWeight: "300-500g",
      arilColor: "Deep ruby red",
      seedType: "Soft",
      brix: "Min 15°"
    },
    grades: ["Super Premium", "Premium", "Standard"],
    packaging: "3kg/5kg boxes",
    shelfLife: "60-90 days (cold storage)",
    certifications: "GlobalGAP, FSSAI"
  },
  {
    id: "banana-cavendish",
    name: "Cavendish Banana",
    botanicalName: "Musa acuminata",
    category: "fresh-fruits",
    subcategory: "banana",
    image: "banana-cavendish",
    description: "Cavendish bananas are the most traded banana variety globally. India is a major producer, with significant exports to Middle East and neighboring countries. Known for consistent quality and year-round availability.",
    origin: "Tamil Nadu, Maharashtra, Gujarat, Andhra Pradesh - India",
    season: "Year-round",
    characteristics: "Medium, curved, yellow when ripe, creamy texture, sweet",
    culinaryUses: "Fresh eating, smoothies, baking, desserts, baby food",
    nutritionalInfo: "Potassium, vitamin B6, vitamin C, dietary fiber",
    specifications: {
      fingerLength: "15-20cm",
      fingerGirth: "Min 12cm circumference",
      color: "Green (Grade 2) to Yellow (Grade 5-6)",
      brix: "Min 18° (ripe)"
    },
    grades: ["Class Extra", "Class I", "Class II"],
    packaging: "13kg/18kg cartons",
    shelfLife: "2-3 weeks (controlled ripening)",
    certifications: "GlobalGAP, FSSAI"
  },
  {
    id: "orange-nagpur",
    name: "Nagpur Orange (Mandarin)",
    botanicalName: "Citrus reticulata",
    category: "fresh-fruits",
    subcategory: "citrus",
    image: "orange-nagpur",
    description: "Nagpur mandarin oranges are famous for their distinctive taste and loose, easy-peel skin. GI-tagged 'Nagpur Orange' is synonymous with quality citrus from central India.",
    origin: "Nagpur (Maharashtra), Madhya Pradesh - India",
    season: "November to February (main), July-August (Ambia)",
    characteristics: "Medium size, loose skin, easy peel, sweet-tangy, segments separate easily",
    culinaryUses: "Fresh eating, juicing, segments in salads and desserts",
    nutritionalInfo: "High vitamin C, flavonoids, fiber, low calories",
    specifications: {
      fruitWeight: "120-180g",
      diameter: "60-80mm",
      brix: "Min 10°",
      acidity: "Max 1%"
    },
    grades: ["GI Tagged Nagpur", "Premium", "Standard"],
    packaging: "10kg/20kg boxes",
    shelfLife: "3-4 weeks (cold storage)",
    certifications: "GI Tag, FSSAI"
  },
  // === FRESH VEGETABLES ===
  {
    id: "onion-red",
    name: "Red Onion",
    botanicalName: "Allium cepa",
    category: "fresh-vegetables",
    subcategory: "allium",
    image: "onion-red",
    description: "Indian red onions are known globally for their pungency and deep red-purple color. Maharashtra and Karnataka are major producers. Essential ingredient in Indian cuisine and widely exported to Gulf, Southeast Asia, and Africa.",
    origin: "Maharashtra (Nashik, Pune), Karnataka, Madhya Pradesh - India",
    season: "Year-round (Rabi: Oct-Jan, Kharif: Apr-Jun)",
    characteristics: "Deep red-purple, pungent, firm layers, stores well",
    culinaryUses: "Cooking base, salads, pickles, dehydration, paste production",
    nutritionalInfo: "Quercetin antioxidants, vitamin C, prebiotic fiber",
    specifications: {
      size: "45-65mm, 65-85mm, 85mm+",
      color: "Deep red to purple",
      dryMatter: "Min 12%",
      pungency: "High"
    },
    grades: ["A Grade (65-85mm)", "B Grade (45-65mm)", "Jumbo (85mm+)"],
    packaging: "25kg/50kg mesh bags",
    shelfLife: "2-3 months (proper storage)",
    certifications: "FSSAI, Phytosanitary"
  },
  {
    id: "potato",
    name: "Potato",
    botanicalName: "Solanum tuberosum",
    category: "fresh-vegetables",
    subcategory: "tuber",
    image: "potato",
    description: "India is a major potato producer with multiple varieties for different uses. Table potatoes for fresh consumption and processing varieties for chips/fries are both available for export.",
    origin: "Uttar Pradesh, West Bengal, Bihar, Gujarat - India",
    season: "Year-round (peak harvest: Feb-Apr)",
    characteristics: "Oval to round, white to yellow flesh, versatile cooking",
    culinaryUses: "Chips, fries, curries, salads, processed products",
    nutritionalInfo: "Vitamin C, potassium, vitamin B6, resistant starch",
    specifications: {
      size: "25-40mm, 40-60mm, 60-80mm, 80mm+",
      dryMatter: "Min 20% (processing)",
      reducingSugars: "Max 0.25% (chips grade)",
      defects: "Max 5%"
    },
    grades: ["Processing Grade", "Table Grade", "Seed Grade"],
    packaging: "25kg/50kg PP bags",
    shelfLife: "3-4 months (cold storage)",
    certifications: "FSSAI"
  },
  {
    id: "green-chilli",
    name: "Green Chilli",
    botanicalName: "Capsicum annuum",
    category: "fresh-vegetables",
    subcategory: "chilli",
    image: "green-chilli",
    description: "Indian green chillies range from mild to extremely hot varieties. They're essential in Indian cuisine and exported fresh, dried, or processed. Major varieties include Jwala, Guntur, and Bullet.",
    origin: "Andhra Pradesh, Karnataka, Maharashtra, Tamil Nadu - India",
    season: "Year-round",
    characteristics: "Bright green, varied heat levels, aromatic, versatile",
    culinaryUses: "Fresh cooking, pickling, paste production, dehydration",
    nutritionalInfo: "Vitamin C, capsaicin, vitamin A, metabolism booster",
    specifications: {
      variety: "Jwala/Bullet/Guntur",
      length: "5-12cm (varies by variety)",
      color: "Bright green",
      heatLevel: "20,000-50,000 SHU (varies)"
    },
    grades: ["Export Grade", "Domestic Grade"],
    packaging: "5kg/10kg cartons",
    shelfLife: "2-3 weeks (cold storage)",
    certifications: "FSSAI"
  },
  {
    id: "fresh-ginger",
    name: "Fresh Ginger",
    botanicalName: "Zingiber officinale",
    category: "fresh-vegetables",
    subcategory: "rhizome",
    image: "fresh-ginger",
    description: "Indian ginger is valued worldwide for its intense flavor and aroma. Kerala, Karnataka, and Northeast states are major producers. Available fresh or processed into various forms.",
    origin: "Kerala, Karnataka, Assam, Meghalaya - India",
    season: "Harvest: Dec-Feb (stored year-round)",
    characteristics: "Fibrous rhizome, golden flesh, pungent, aromatic",
    culinaryUses: "Cooking, beverages, paste, confectionery, medicinal uses",
    nutritionalInfo: "Gingerols, shogaols, anti-inflammatory compounds",
    specifications: {
      size: "150-250g hands",
      moistureContent: "Max 86%",
      volatileOil: "Min 1.5%",
      fiber: "Minimal (young ginger)"
    },
    grades: ["Export Grade", "Fresh Young", "Mature"],
    packaging: "10kg/20kg cartons",
    shelfLife: "3-4 weeks (refrigerated)",
    certifications: "FSSAI, Phytosanitary"
  },
  {
    id: "fresh-garlic",
    name: "Fresh Garlic",
    botanicalName: "Allium sativum",
    category: "fresh-vegetables",
    subcategory: "allium",
    image: "fresh-garlic",
    description: "Indian garlic is known for its strong pungency and small to medium clove sizes. Major production in Madhya Pradesh, Gujarat, and Rajasthan. Exported fresh and processed.",
    origin: "Madhya Pradesh, Gujarat, Rajasthan, Uttar Pradesh - India",
    season: "Harvest: Feb-Apr (stored year-round)",
    characteristics: "Multiple cloves, papery skin, pungent, strong flavor",
    culinaryUses: "Cooking base, paste, pickle, medicinal, dehydrated products",
    nutritionalInfo: "Allicin, vitamin C, vitamin B6, selenium",
    specifications: {
      bulbSize: "35-45mm, 45-55mm, 55mm+",
      cloves: "15-25 per bulb",
      moisture: "Max 65%",
      pungency: "High"
    },
    grades: ["Premium (55mm+)", "Standard (45-55mm)", "Small (35-45mm)"],
    packaging: "10kg/20kg mesh bags",
    shelfLife: "4-6 months (proper storage)",
    certifications: "FSSAI, Phytosanitary"
  },
  {
    id: "okra",
    name: "Okra (Lady Finger)",
    botanicalName: "Abelmoschus esculentus",
    category: "fresh-vegetables",
    subcategory: "tender-vegetable",
    image: "okra",
    description: "Indian okra, known as bhindi or lady finger, is a popular vegetable exported to Middle East, UK, and US markets with diaspora populations. Known for its tender texture and mucilaginous quality.",
    origin: "Gujarat, Maharashtra, Andhra Pradesh, West Bengal - India",
    season: "Summer crop (Mar-Jul), Kharif (Jun-Oct)",
    characteristics: "Tender pods, bright green, ridged, mucilaginous when cut",
    culinaryUses: "Stir-fries, curries, pickles, gumbo, Middle Eastern dishes",
    nutritionalInfo: "Vitamin C, vitamin K, folate, fiber, antioxidants",
    specifications: {
      length: "7-12cm (tender)",
      color: "Bright green",
      freshness: "Snaps when bent",
      seeds: "Immature, soft"
    },
    grades: ["Export Grade", "Domestic Grade"],
    packaging: "4kg/6kg punnets, 10kg cartons",
    shelfLife: "7-10 days (cold storage)",
    certifications: "GlobalGAP, FSSAI"
  },
  // === PROCESSED FRUITS ===
  {
    id: "mango-pulp",
    name: "Mango Pulp/Puree",
    botanicalName: "Mangifera indica",
    category: "processed-fruits",
    subcategory: "pulp-puree",
    image: "mango-pulp",
    description: "Indian mango pulp is exported worldwide for use in beverages, desserts, and food manufacturing. Available in Alphonso, Totapuri, and Kesar varieties with different flavor profiles and price points.",
    origin: "Maharashtra, Gujarat, Andhra Pradesh, Karnataka - India",
    season: "Production: Apr-Jul, Available year-round",
    characteristics: "Smooth puree, intense mango flavor, preserved quality",
    culinaryUses: "Beverages, ice cream, yogurt, bakery, confectionery, baby food",
    nutritionalInfo: "Vitamin A, vitamin C, natural sugars, fiber",
    specifications: {
      variety: "Alphonso/Totapuri/Kesar",
      brix: "14-18° (varies by variety)",
      acidity: "0.3-0.6%",
      consistency: "Smooth puree",
      preservation: "Aseptic/Frozen/Canned"
    },
    grades: ["Alphonso (Premium)", "Kesar (Mid-segment)", "Totapuri (Economy)"],
    packaging: "3.1kg cans, 215kg drums, aseptic bags",
    shelfLife: "24 months (aseptic), 18 months (canned)",
    certifications: "FSSAI, HACCP, BRC, Kosher available"
  },
  {
    id: "tomato-paste",
    name: "Tomato Paste",
    botanicalName: "Solanum lycopersicum",
    category: "processed-vegetables",
    subcategory: "paste-concentrate",
    image: "tomato-paste",
    description: "Indian tomato paste is produced from fresh, ripe tomatoes processed into concentrated form. Available in various concentrations for industrial food manufacturing and retail use.",
    origin: "Maharashtra, Karnataka, Andhra Pradesh, Gujarat - India",
    season: "Year-round production",
    characteristics: "Deep red, concentrated, rich tomato flavor, smooth texture",
    culinaryUses: "Sauces, soups, ketchup manufacturing, pizza base, ready meals",
    nutritionalInfo: "Lycopene (concentrated), vitamin C, potassium",
    specifications: {
      brix: "28-30° (single), 36-38° (double)",
      color: "Deep red (12+ Agtron)",
      acidity: "3.5-4.5 pH",
      consistency: "Smooth, no seeds"
    },
    grades: ["Hot Break", "Cold Break", "Various Brix levels"],
    packaging: "400g cans, 3.1kg cans, 220kg drums, aseptic bags",
    shelfLife: "24 months",
    certifications: "FSSAI, HACCP, BRC"
  },
  {
    id: "dehydrated-onion",
    name: "Dehydrated Onion",
    botanicalName: "Allium cepa",
    category: "processed-vegetables",
    subcategory: "dehydrated",
    image: "dehydrated-onion",
    description: "India is a leading exporter of dehydrated onion products. Available in various forms - flakes, minced, chopped, granules, and powder - for food industry applications worldwide.",
    origin: "Maharashtra, Gujarat, Rajasthan - India",
    season: "Year-round production",
    characteristics: "Preserved onion flavor, extended shelf life, easy reconstitution",
    culinaryUses: "Snack seasonings, instant foods, soup mixes, sauces, spice blends",
    nutritionalInfo: "Concentrated onion nutrients, quercetin, prebiotic fiber",
    specifications: {
      moisture: "Max 6%",
      color: "White to creamy white",
      form: "Flakes/Minced/Chopped/Granules/Powder",
      rehydrationRatio: "1:5 to 1:7"
    },
    grades: ["A Grade", "B Grade", "C Grade"],
    packaging: "10kg/25kg cartons, bulk bags",
    shelfLife: "18-24 months",
    certifications: "FSSAI, BRC, HACCP, Kosher, Halal"
  },
  {
    id: "dehydrated-garlic",
    name: "Dehydrated Garlic",
    botanicalName: "Allium sativum",
    category: "processed-vegetables",
    subcategory: "dehydrated",
    image: "dehydrated-garlic",
    description: "Dehydrated garlic from India retains the pungency and flavor of fresh garlic with extended shelf life. Available in flakes, minced, granules, and powder forms for diverse applications.",
    origin: "Madhya Pradesh, Gujarat, Rajasthan - India",
    season: "Year-round production",
    characteristics: "Concentrated garlic flavor, long shelf life, easy use",
    culinaryUses: "Seasoning blends, snacks, sauces, processed foods, instant meals",
    nutritionalInfo: "Concentrated allicin compounds, minerals",
    specifications: {
      moisture: "Max 6%",
      color: "Off-white to light cream",
      form: "Flakes/Minced/Chopped/Granules/Powder",
      volatileOil: "Min 0.3%"
    },
    grades: ["A Grade", "B Grade"],
    packaging: "10kg/25kg cartons",
    shelfLife: "18-24 months",
    certifications: "FSSAI, BRC, HACCP, Kosher, Halal"
  },
  {
    id: "frozen-vegetables-mix",
    name: "Frozen Mixed Vegetables",
    botanicalName: "Various",
    category: "processed-vegetables",
    subcategory: "frozen",
    image: "frozen-vegetables",
    description: "IQF (Individually Quick Frozen) mixed vegetables preserve the nutrition and taste of fresh produce. Available in various mixes suited for different cuisines and applications.",
    origin: "Maharashtra, Gujarat, Punjab - India",
    season: "Year-round production",
    characteristics: "IQF technology, retained nutrition, ready to cook",
    culinaryUses: "Ready meals, foodservice, retail packs, catering",
    nutritionalInfo: "Preserved vitamins and minerals from fresh state",
    specifications: {
      products: "Peas, Corn, Carrots, Beans, Cauliflower, etc.",
      temperature: "-18°C storage",
      blanching: "Steam blanched",
      freezing: "IQF method"
    },
    grades: ["Retail Grade", "Foodservice Grade", "Industrial Grade"],
    packaging: "500g/1kg retail, 10kg bulk bags",
    shelfLife: "24 months (-18°C)",
    certifications: "FSSAI, HACCP, BRC"
  },
  {
    id: "pickle-mango",
    name: "Mango Pickle (Aachar)",
    botanicalName: "Mangifera indica",
    category: "processed-fruits",
    subcategory: "pickle-preserve",
    image: "pickle-mango",
    description: "Traditional Indian mango pickle is made from raw mangoes preserved in oil and spices. A staple condiment in Indian cuisine, it's now popular globally for its unique tangy, spicy flavor.",
    origin: "Andhra Pradesh, Tamil Nadu, Gujarat, Rajasthan - India",
    season: "Year-round (raw mango processing in spring)",
    characteristics: "Tangy, spicy, oil-based, traditional recipe",
    culinaryUses: "Condiment with rice and bread, flavor enhancer, Indian cuisine essential",
    nutritionalInfo: "Probiotics (fermented), spice benefits, vitamin C from mango",
    specifications: {
      style: "Cut mango/Stuffed/Shredded",
      oil: "Sesame/Mustard/Groundnut",
      spiceLevel: "Mild to Hot",
      acidity: "Preserved naturally"
    },
    grades: ["Traditional Recipe", "Low Oil", "Export Formulation"],
    packaging: "200g/400g/1kg jars, 5kg bulk",
    shelfLife: "12-18 months",
    certifications: "FSSAI, HACCP"
  },
  {
    id: "guava-pulp",
    name: "Guava Pulp/Puree",
    botanicalName: "Psidium guajava",
    category: "processed-fruits",
    subcategory: "pulp-puree",
    image: "guava-pulp",
    description: "Indian guava pulp is made from pink and white varieties. Used extensively in beverages, nectars, and dairy products. Rich in vitamin C and pectin for natural thickening.",
    origin: "Uttar Pradesh, Maharashtra, Bihar, Andhra Pradesh - India",
    season: "Year-round production (peak: Aug-Dec)",
    characteristics: "Pink or white, natural pectin, tropical flavor",
    culinaryUses: "Juices, nectars, ice cream, yogurt, baby food, bakery",
    nutritionalInfo: "Highest vitamin C among fruits, dietary fiber, potassium",
    specifications: {
      variety: "Pink/White",
      brix: "8-11°",
      pulpContent: "Min 85%",
      preservation: "Aseptic/Frozen"
    },
    grades: ["Pink (Premium)", "White (Standard)"],
    packaging: "3.1kg cans, 215kg drums, aseptic bags",
    shelfLife: "24 months (aseptic)",
    certifications: "FSSAI, HACCP, BRC"
  },
  {
    id: "coconut-products",
    name: "Coconut Products (Milk/Cream/Water)",
    botanicalName: "Cocos nucifera",
    category: "processed-fruits",
    subcategory: "coconut",
    image: "coconut-products",
    description: "India produces a range of coconut products including coconut milk, cream, water, and desiccated coconut. These are essential ingredients in Asian and tropical cuisines worldwide.",
    origin: "Kerala, Tamil Nadu, Karnataka, Andhra Pradesh - India",
    season: "Year-round",
    characteristics: "Various forms preserving coconut flavor and nutrition",
    culinaryUses: "Curries, desserts, beverages, baking, vegan alternatives",
    nutritionalInfo: "MCTs, lauric acid, potassium, electrolytes (water)",
    specifications: {
      products: "Milk (17-22% fat), Cream (24-26% fat), Water, Desiccated",
      fatContent: "Varies by product",
      additives: "None or guar gum stabilizer",
      preservation: "UHT/Aseptic/Frozen"
    },
    grades: ["Premium", "Standard", "Light versions"],
    packaging: "400ml cans, 1L Tetra, bulk drums",
    shelfLife: "18-24 months (UHT)",
    certifications: "FSSAI, HACCP, Vegan certified"
  }
];

// Get all unique categories
export const produceCategories = [...new Set(produceData.map(p => p.category))];

// Get produce by ID
export const getProduceById = (id) => produceData.find(p => p.id === id);

// Get produce by category
export const getProduceByCategory = (category) => produceData.filter(p => p.category === category);

// Category labels
export const produceCategoryLabels = {
  "fresh-fruits": "Fresh Fruits",
  "fresh-vegetables": "Fresh Vegetables",
  "processed-fruits": "Processed Fruits",
  "processed-vegetables": "Processed Vegetables"
};
